import { CreditMemo } from "@dana/Services/CreditService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { CreditStateActions } from "@dana/Store/Data/ViewCredit/Reducers/ViewCreditReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getOrders } from "@insite/client-framework/Services/OrderService";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{}, DispatchProp<CreditStateActions>>;

export const DispatchBeginExportCredits: HandlerType = props => {
    props.dispatch({
        type: "CreditViewState/IsLoading",
        isLoading: true,
    });
};

export const ExportData: HandlerType = async props => {
    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");

    let data: any[] = [];
    const state = props.getState();
    const language = state.context.session.language;
    const danaState = props.getState() as ApplicationStateDana;
    const allCredits: CreditMemo[] = danaState.viewCreditState.allCredits;
    if (allCredits.length) {
        
        const creditMemoNoKey = translate("Credit Memo No.");
        const primaryPOKey = translate("Primary PO No.");
        const secondaryPOKey = translate("Secondary PO No.");
        const danaPartNoKey = translate("Dana Part No.");
        const customerPartNoKey = translate("Customer Part No.");
        const partQtyKey = translate("Part Qty");
        const creditMemoDateKey = translate("Credit Memo Date");
        const creditMemoTotalKey = translate("Credit Memo Total");
        const appliedCreditsKey = translate("Applied Credits");
        const openCreditsKey = translate("Open Credits");

        const rows = allCredits?.map((credit: CreditMemo) => {

            return {
                [creditMemoNoKey]: credit.creditMemoNumber,
                [primaryPOKey]: credit.originalPONumber ?? "",
                [secondaryPOKey]: credit.secondaryPONumber ?? "",
                [danaPartNoKey]: credit.partNumbers?.join(",") ?? "",
                [customerPartNoKey]: credit.customerPartNumber ?? "",
                [partQtyKey]: credit.partQuantity ?? "",
                [creditMemoDateKey]: credit.creditMemoDate
                    ? getLocalizedDateTime({
                        dateTime: new Date(credit.creditMemoDate),
                        language,
                    })
                    : "",
                [creditMemoTotalKey]: credit.creditMemoAmount ?? "",
                [appliedCreditsKey]: credit.appliedCredits ?? "",
                [openCreditsKey]: credit.openCredits ?? "",
            };
        }) ?? [];

        for (const row of rows) {
            data.push(row);
        }

        const csv = unparse(data);
        const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

        const fileName = `view_credits.csv`;
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(csvBlob);
        downloadLink.setAttribute("download", fileName);
        downloadLink.click();
    }


};

export const DispatchCompleteExportCredits: HandlerType = props => {
    props.dispatch({
        type: "CreditViewState/IsLoading",
        isLoading: false,
    });
};

export const chain = [DispatchBeginExportCredits, ExportData, DispatchCompleteExportCredits];

const exportCredits = createHandlerChainRunner(chain, "ExportCredits");
export default exportCredits;
